
ACC.contactpagebuttons = {

  errclass: '.ph-ctform__error',
  errfield: 'form_field_error ph-form_field_error',
  errs: '.ph-contact__questions .form_field_error',
  emptyval: '.ph-ctform__emptyvalue',

  email: function(value) {
    /* eslint-disable  security/detect-unsafe-regex */
    var ckEmail = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

    /* eslint-enable  security/detect-unsafe-regex */
    if (ckEmail.test(value)) {
      return false;
    }

    return true;
  },

  chkphone: function(value) {
    if ((/^\+[1-9]{1}\d{1,14}$/).test(value)) {
      return false;
    }

    return true;
  },


  errorInfo: function(resthis) {
    var errormsgValue = $(resthis).parents(ACC.contactpagebuttons.errclass).parent().attr('data-emptyContent');

    $(resthis).parents(ACC.contactpagebuttons.errclass).addClass(ACC.contactpagebuttons.errfield);
    $(resthis).parents(ACC.contactpagebuttons.errclass).find(ACC.contactpagebuttons.emptyval).text(errormsgValue);
  },

  removeInfo: function(resthis) {
    $(resthis).parents(ACC.contactpagebuttons.errclass).removeClass(ACC.contactpagebuttons.errfield);
    $(resthis).parents(ACC.contactpagebuttons.errclass).find(ACC.contactpagebuttons.emptyval).text('');
  },

  addRemove: function(perthis) {
    if ($(perthis).val().trim() === '' || $(perthis).val() === null) {
      ACC.contactpagebuttons.errorInfo(perthis);
    } else {
      ACC.contactpagebuttons.removeInfo(perthis);
    }
  },

  selectFirst: function(selthis, getId) {
    var errorMessageSelectBox = $(selthis).parents('#' + getId).attr('data-emptyContent');

    $(selthis).parents('.ph-signup__error').addClass(ACC.contactpagebuttons.errfield);
    $(selthis).parents('.ph-signup__error').find('.ph-register__emptyvalue').text(errorMessageSelectBox);
  },

  personalprof: function() {
    var getId = '',
        $fieldItem = $('#userTitle');

    if ($fieldItem.val() === '' || $fieldItem.val() === null) {
      getId = $fieldItem.parents('.ph-inputData').attr('id');
      ACC.contactpagebuttons.selectFirst($fieldItem, getId);

      return false;
    }

    return true;
  },

  nextbtnquestion: function() {
    $(document).on('click', '.ph-contact__question', function() {
      var personalProfile = true;
      var txtde = '#txtDesc';
      var qtype = '.ph-qtype';
      var ordertxt = '#ph-ordertxt input[type="text"]';

      if ($(txtde).val() === '') {
        personalProfile = false;
      }

      if (personalProfile === false) {
        ACC.contactpagebuttons.addRemove($(txtde));
      }

      if ($(qtype).val() === '') {
        ACC.contactpagebuttons.addRemove($(qtype));
      }

      if ($(qtype).val() === 'Q02') {
        ACC.contactpagebuttons.addRemove($(ordertxt));
      } else {
        ACC.contactpagebuttons.removeInfo($(ordertxt));
      }

      if ($(ACC.contactpagebuttons.errs).length > 0) {
        return false;
      }

      location.hash = 'moredetails';

      return true;
    });
  },

  nextbtncontact: function() {
    $(document).on('click', '.ph-contact__confirm', function() {
      var personalProfile = true;
      var inputs = '.ph-contact__questions .ph-secondtab input[type="text"]';

      $(inputs).each(function() {
        if ($(this).val().trim() === '') {
          personalProfile = false;
        }
      });

      if (personalProfile === false) {
        $(inputs).each(function() {
          ACC.contactpagebuttons.addRemove(this);
        });
        ACC.contactpagebuttons.personalprof();
      }

      ACC.contactpagebuttons.personalprof();

      if ($(ACC.contactpagebuttons.errs).length > 0) {
        return false;
      }

      /* eslint-disable xss/no-mixed-html */
      $.colorbox({
        width: '500px',
        maxWidth: '90%',
        height: '180px',
        scrolling: false,
        html: $('.ph-popupdata').html(),
        overlayClose: false,
        closeButton: false,
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });

      /* eslint-enable xss/no-mixed-html */
      return true;
    });
  },
  chkCode: function() {
    var ccode = $('#ccode').val();
    var count = 0,
        found = false,
        phn = '#phone',
        ccodes = ACC.countrycodes.codes();

    for (count in ccodes) {
      if (ccodes[count].code === ccode) {
        $(phn).val(ccodes[count].dial_code);
        $('#cname').val(ccodes[count].name);
        found = true;
      }
    }

    if (!found) {
      $(phn).val('+');
    }
  },
  supportClick: function() {
    var txtdesc = '#txtDesc',
        odesc = '#ph-ordertxt',
        odescinput = '#ph-ordertxt input',
        txtaddr = '.ph-secondtab input[type="text"]',
        qtype = '.ph-qtype',
        qlabel = '#questionlabel',
        ordnum = '.ph-optionalfield',
        subjectquestion = '#subject',
        selectOption = 'selected',
        rest = window.location.href.substring(0, window.location.href.lastIndexOf('/') + 1);

    $('#retURL').val(rest + 'success');
    $(qtype).on('change', function() {
      if (this.value === 'Q02') {
        $(odesc).show();
      } else {
        $(odesc).hide();
      }

      // eslint-disable-next-line no-negated-condition
      if (this.value !== '') {
        $(qlabel).text($(qlabel).attr('data-val') + ' ' + $(this).find('option:' + selectOption).text());
      } else {
        $(qlabel).text($(qlabel).attr('data-val'));
      }
    });

    $(document).on('blur', qtype, function() {
      ACC.contactpagebuttons.addRemove($(qtype));
    });

    $(document).on('focus', qtype, function() {
      ACC.contactpagebuttons.removeInfo($(qtype));
    });

    $(document).on('blur', ordnum, function() {
      ACC.contactpagebuttons.addRemove($(ordnum));
    });

    $(document).on('focus', ordnum, function() {
      ACC.contactpagebuttons.removeInfo($(ordnum));
    });

    $(document).on('blur', txtdesc, function() {
      ACC.contactpagebuttons.addRemove($(txtdesc));
    });

    $(document).on('focus', txtdesc, function() {
      ACC.contactpagebuttons.removeInfo($(txtdesc));
    });

    $(document).on('click', '.ph-ct-goback', function(event) {
      event.preventDefault();
      $('.ph-contact__questions .ph-secondtab input[type="text"]').each(function() {
        ACC.contactpagebuttons.removeInfo(this);
      });
      location.hash = 'question';
    });

    $(document).on('change', qtype, function() {
      if ($(this).val() === '') {
        ACC.contactpagebuttons.addRemove($(qtype));
        $(subjectquestion).val('');
      } else if (this.value === 'Q02') {
        ACC.contactpagebuttons.removeInfo($(qtype));
        $(subjectquestion).val($(this).find('option:' + selectOption).text() + '-' + $(ordnum).val());
      } else {
        ACC.contactpagebuttons.removeInfo($(qtype));
        $(subjectquestion).val($(this).find('option:' + selectOption).text());
      }
    });

    $(document).on('blur', odescinput, function() {
      $(subjectquestion).val($(qtype).find('option:' + selectOption).text() + '-' + $(this).val());
    });

    $(document).on('blur', txtaddr, function() {
      ACC.contactpagebuttons.addRemove($(this));
    });

    $(document).on('blur', '#emailfield input', function() {
      var errormsgValue = $(this).parents(ACC.contactpagebuttons.errclass).parent().attr('data-emailContent');

      if (ACC.contactpagebuttons.email($(this).val())) {
        $(this).parents(ACC.contactpagebuttons.errclass).addClass(ACC.contactpagebuttons.errfield);
        $(this).parents(ACC.contactpagebuttons.errclass).find(ACC.contactpagebuttons.emptyval).text(errormsgValue);
      }
    });

    $(document).on('focus', txtaddr, function() {
      ACC.contactpagebuttons.removeInfo($(this));
    });

    $(document).on('blur', '#phone', function() {
      var errormsgValue = $(this).parents(ACC.contactpagebuttons.errclass).parent().attr('data-invaidct');

      if (ACC.contactpagebuttons.chkphone($(this).val())) {
        $(this).parents(ACC.contactpagebuttons.errclass).addClass(ACC.contactpagebuttons.errfield);
        $(this).parents(ACC.contactpagebuttons.errclass).find(ACC.contactpagebuttons.emptyval).text(errormsgValue);
      }
    });

    if ($('#phone').val() === '') {
      ACC.contactpagebuttons.chkCode();
    }
  }
};

$(document).ready(function() {
  $(document).on('click', '.ph-contact__confirm', function() {
    var urlLink = ACC.config.encodedContextPath + '/support/success',
        navDesc = $('.ph-supportFold-supportForm .ph-supportFold-call-text').text(),
        desc = navDesc + ' - ' + $(this).val().trim(),
        trigger = 'linkCategory.clickConfirmAndSend',
        compname = 'ph-contact__confirm',
        userEventObj = '';

    userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });
  $(document).on('click', '.ph-ct-goback', function() {
    var urlLink = ACC.config.encodedContextPath + '/support/customersupport#question',
        navDesc = $('.ph-supportFold-supportForm .ph-supportFold-call-text').text(),
        desc = navDesc + ' - ' + $(this).text(),
        trigger = 'linkCategory.clickBack',
        compname = 'ph-ct-goback',
        userEventObj = '';

    userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });
  $(document).on('click', '.ph-supportFold-call', function() {
    var urlLink = window.location.href,
        desc = $(this).find('.ph-supportFold-call-text').text(),
        trigger = 'linkCategory.clickCallUs',
        compname = 'ph-supportFold-call',
        userEventObj = '';

    userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });
  $(document).on('click', '.ph-supportFold-supportForm', function() {
    var urlLink = ACC.config.encodedContextPath + '/support/customersupport#question',
        desc = $(this).find('.ph-supportFold-call-text').text(),
        trigger = 'linkCategory.clickSupportForm',
        compname = 'ph-supportFold-supportForm',
        userEventObj = '';

    userEventObj = ACC.googleanalytics.createUserEventForGa(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });

  if ($('.page-csupport').length > 0) {
    ACC.contactpagebuttons.nextbtnquestion();
    ACC.contactpagebuttons.nextbtncontact();
    ACC.contactpagebuttons.supportClick();
    setTimeout(function() {
      location.hash = 'question';
    }, 800);
  }
});
